import { useContext, createContext } from 'react';

import { EUserRole } from '@/enum';

export interface IAuthLayoutContext {
  role: EUserRole;
  setRole: (role: EUserRole) => void;
}

export const AuthLayoutContext = createContext<IAuthLayoutContext | null>(null);

export const useAuthRole = (): IAuthLayoutContext => {
  const ctx = useContext(AuthLayoutContext);
  if (!ctx) {
    throw new Error('useAuthRole must be used within <AuthLayout>');
  }
  return ctx;
};
